import React from "react";
import CustomTable from "../../../components/CustomTable";
import { StatusBadge } from "../../../../../constants/statusConstants";

const StaffTable = ({
    data,
    loading,
    currentPage,
    setCurrentPage,
    totalPages,
    itemsPerPage,
    setItemsPerPage,
    setView,
    setEdit,
    handleEdit,
    setDelete,
    handleDelete,
    basePath,
}) => {
    const columns = [
        {
            key: "stt",
            title: "STT",
            minWidth: "60px",
            align: "text-left",
            render: (value) => <div className="pl-2">{value}</div>,
        },
        {
            key: "staffCode",
            title: "Mã nhân viên",
            color: "text-[#0954E9]",
            minWidth: "120px",
        },
        { key: "fullName", title: "Họ tên", minWidth: "180px" },
        { key: "email", title: "Tên tài khoản / Email", minWidth: "220px" },
        { key: "phone", title: "Số điện thoại", minWidth: "140px" },
        {
            key: "departmentName",
            title: "Phòng ban trực thuộc",
            minWidth: "180px",
        },
        // {
        //     key: "responsibleDepartments",
        //     title: "Phòng ban phụ trách",
        //     minWidth: "220px",
        //     render: (value) => {
        //         if (!value || value?.length === 0) return <div className="pl-3 text-gray-400">Chưa có</div>;
        //         return (
        //             <div className="flex flex-wrap gap-1">
        //                 {value?.map((dept, idx) => (
        //                     <div key={idx} className="bg-[#EEF4FF] text-[#0954E9] px-3 py-1 rounded-full text-xs font-medium inline-block whitespace-nowrap">
        //                         {dept}
        //                     </div>
        //                 ))}
        //             </div>
        //         );
        //     },
        // },
        { key: "role", title: "Chức vụ", minWidth: "140px" },
        { key: "joinDate", title: "Ngày vào làm", minWidth: "140px" },
        {
            key: "status",
            title: "Trạng thái",
            minWidth: "140px",
            render: (value) => <StatusBadge status={value} />,
        },
    ];

    return (
        <CustomTable
            data={data}
            loading={loading}
            columns={columns}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            getRowId={(item) => item._id || item.id}
            setView={setView}
            setEdit={setEdit}
            handleEdit={handleEdit}
            setDelete={setDelete}
            handleDelete={handleDelete}
            basePath={basePath}
        />
    );
};

export default StaffTable;
